/**
 * BulkActionsBar — sticky action bar shown when at least one CRM lead
 * checkbox is ticked. V2.1.1 iter183 (Feb 28, 2026).
 *
 * Kept intentionally minimal: three actions (reassign, disposition,
 * clear). No dropdown — flat buttons for tap-and-go on mobile too.
 */
import React from "react";
import { UserSwitch, ListChecks, X, WhatsappLogo } from "@phosphor-icons/react";

export default function BulkActionsBar({
    selectedCount,
    onReassign,
    onDisposition,
    onWhatsApp,
    onClear,
}) {
    if (!selectedCount) return null;
    return (
        <div
            data-testid="crm-bulk-actions-bar"
            className="sticky top-0 z-10 mb-3 border-2 border-ink bg-ink text-white flex items-center gap-3 px-4 py-2"
        >
            <span
                data-testid="crm-bulk-count"
                className="font-heading font-black text-sm tracking-tight"
            >
                {selectedCount} selected
            </span>
            <div className="flex-1" />
            <button
                onClick={onWhatsApp}
                data-testid="crm-bulk-wa-btn"
                className="text-[11px] font-black uppercase tracking-wider bg-emerald-600 hover:bg-white hover:text-emerald-700 px-3 py-1.5 border-2 border-emerald-600 transition inline-flex items-center gap-1"
            >
                <WhatsappLogo size={14} weight="bold" /> WhatsApp link
            </button>
            <button
                onClick={onReassign}
                data-testid="crm-bulk-reassign-btn"
                className="text-[11px] font-black uppercase tracking-wider bg-cobalt hover:bg-white hover:text-cobalt px-3 py-1.5 border-2 border-cobalt transition inline-flex items-center gap-1"
            >
                <UserSwitch size={14} weight="bold" /> Reassign
            </button>
            <button
                onClick={onDisposition}
                data-testid="crm-bulk-disposition-btn"
                className="text-[11px] font-black uppercase tracking-wider bg-white text-ink hover:bg-cobalt hover:text-white px-3 py-1.5 border-2 border-white transition inline-flex items-center gap-1"
            >
                <ListChecks size={14} weight="bold" /> Disposition
            </button>
            <button
                onClick={onClear}
                data-testid="crm-bulk-clear-btn"
                aria-label="Clear selection"
                className="text-white hover:text-cobalt p-1"
            >
                <X size={16} weight="bold" />
            </button>
        </div>
    );
}
